import type { GeolocationDetails } from '@dte/otw-azure-functions/src/common/interfaces/api/Location';
import type { PremiseDataDocument } from '@dte/otw-azure-functions/src/common/interfaces/containers/premises/PremiseData';

export function getPremiseGPS(masterData: PremiseDataDocument | undefined): GeolocationDetails | undefined {
	// GeoJSON coordinates
	const coordinates = masterData?.data?.gps?.coordinates;
	const longitude = coordinates?.[0];
	const latitude = coordinates?.[1];

	if (!latitude || !longitude) {
		return undefined;
	}

	return {
		latitude: latitude,
		longitude: longitude,
	};
}
